export default __webpack_public_path__ + "static/media/inactive-event.5aee50c7.png";